import { RpcExtensionBrokerRequestResult } from './rpc-extension-broker-model';

/**
 * Rpc extension broker response server side handler interface.
 */
export interface RpcExtensionBrokerResponseHandler {
    handler(data: RpcExtensionBrokerRequestResult): Promise<void>;
}
